jQuery(document).ready(function($) {

	$.accordion = {
		init: function() {
			$.accordion.init_accordions();
		},

		init_accordions: function() {
			$('.accordion').each(function() {
				$(this).find('.accordion-toggle').click(function() {

					//Expand or collapse this panel
					$(this).parent('.accordion').toggleClass('open');
					$(this).parents('.accordion').find('.accordion-content').stop().slideToggle('500');

					var controlElement = $(this).attr('aria-controls');

					if ($(this).parent('.accordion').hasClass('open')) {
						$('#'+controlElement).attr('aria-hidden', false)
						$(this).attr('aria-expanded', true);
					} else {
						$('#'+controlElement).attr('aria-hidden', true)
						$(this).attr('aria-expanded', false);
					}
					
					// $(this).next().stop().slideToggle('500');

					//Hide the other panels
					//$(".accordion-content").not($(this).next()).slideUp('500');

				});
			});
		},
	};

});